import React from "react";
import style from "./index.module.scss";
import { Spin } from "antd";
import ListItem from "../ListItem";
import useRequest from "../../../../../utils/useRequest";
import { getLiveRecord, LiveRecord } from "../../../../../service/liveRecord";
import CustomEmpty from "../../../../../components/CourseComponents/CustomEmpty";
interface LiveRecordData {
    listData: LiveRecord;
}

export default function MainScreen({ listData }: LiveRecordData) {
    const [data, { loading }, refreshData] = useRequest(
        () => getLiveRecord(listData),
        {}
    );
    return (
        <div className={style.root}>
            <Spin spinning={loading}>
                <div className={style.header}>
                    <div className={style.count}>
                        三分屏回放（{data?.length || 0}）
                        <span className={style.tip}>
                            温馨提示：一旦选择删除回放，回放删除成功后将无法恢复，请谨慎操作。
                        </span>
                    </div>
                </div>

                {/* {data && data.length !== 0 && (
                    <Alert
                        message="说明：如想下载主屏视频，请鼠标右键点击视频记录，然后选择“链接存储为…“"
                        type="warning"
                        showIcon
                        className={style.alertMsg}
                    />
                )} */}

                {data?.length !== 0 &&
                    data?.map(item => (
                        <ListItem
                            key={item.vid}
                            data={item}
                            onChange={refreshData}
                        />
                    ))}
                {data?.length === 0 && (
                    <CustomEmpty style={{ padding: "100px 0" }} />
                )}
            </Spin>
        </div>
    );
}
